// extracted by mini-css-extract-plugin
export default {"scale1":"1.25em","scale2":"1.5625em","scale3":"1.953125em","scale4":"2.44140625em","scale5":"3.0517578125em"};